import { mergeAttributes, Node } from '@tiptap/core'

export interface DivOptions {
  /**
   * The HTML attributes for a div node.
   * @default {}
   * @example { class: 'foo' }
   */
  HTMLAttributes: Record<string, any>,
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    div: {
      /**
       * Toggle a div
       * @example editor.commands.toggleDiv()
       */
      setDiv: () => ReturnType,
    }
  }
}

/**
 * This extension allows you to create divs.
 * based on 
 * @see https://www.tiptap.dev/api/nodes/paragraph
 */
export const DivNode = Node.create<DivOptions>({
  name: 'div',

  priority: 100,

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  group: 'block',

  content: 'block*',

  addAttributes() {
    return {
      class: {
        default: null,
      },
      style: {
        default: null,
      },
      id: {
        default: null,
      },
    }
  },

  parseHTML() {
    return [
      { tag: 'div' },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0]
  },

  addCommands() {
    return {
      setDiv: () => ({ commands }) => {
        return commands.setNode(this.name)
      },
    }
  },

  addKeyboardShortcuts() {
    return {
      'Mod-Alt-D': () => this.editor.commands.setDiv(),
    }
  },
})